export const convertFieldNameToLowerCase = (array) => {
    for(let c = 0; c <= array.length - 1; c++){
        const obj = array[c]
        if (obj?.fieldname) {
            obj["fieldname"] = obj?.fieldname.toLowerCase()
        }
    }
}
